export default __webpack_public_path__ + "static/franchise-3-a60dc786504bf9ad8a47dac1966a443c.jpg";